import type { AttachmentType } from 'src/__generated__/graphql';
import { apolloClient } from 'src/modules/graphql-client';
import { getOperationNameFromQuery } from 'src/modules/utils';

import { logError } from '../../modules/error-logger/browserLog';

import { PROCESS_UPLOADED_ATTACHMENT } from './process-uploaded-attachment.graphql';

export const processUploadedAttachment = ({
  attachmentId,
  attachmentType,
}: {
  attachmentId: string;
  attachmentType: AttachmentType;
}) =>
  apolloClient
    .mutate({
      mutation: PROCESS_UPLOADED_ATTACHMENT,
      variables: {
        input: {
          id: attachmentId,
          attachmentType,
        },
      },
      errorPolicy: 'all',
    })
    .catch((err) => {
      logError(
        {
          ...err,
          type: 'process-uploaded-attachment',
        },
        {
          error: err,
          attachmentType,
          attachmentId,
          operationName: getOperationNameFromQuery(PROCESS_UPLOADED_ATTACHMENT),
        },
      );
      return null;
    })
    .then((res) => {
      const uri = res?.data?.processUploadedAttachment?.uri;
      const errors = res?.errors || [];
      const validation = errors.reduce((acc, current: any) => {
        const validationErrors: Record<string, string[]> =
          current.extensions?.validationErrors || {};

        const flattened = Object.values(validationErrors);
        return acc.concat(...flattened);
      }, [] as string[]);

      const validationError = validation[0] || '';

      if (validationError) {
        throw new Error(validationError);
      }

      if (!uri) {
        throw new Error('Error uploading attachment');
      }

      return uri;
    });
